import { useCalculatedResults } from '@react-query/hooks/use-calculated-results';

export const useResultsExpectedRate = () => {
    const { data: calculatedFundSavings } = useCalculatedResults();

    if (!calculatedFundSavings) {
        return null;
    }

    return calculatedFundSavings.expected;
};
